import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKAlert from "components/MKAlert";
import MKButton from "components/MKButton";
import MKInput from "components/MKInput";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Routes
import routes from "routes";

//api
import { exportCidToReverseDebtTracking } from "api/register";

//util
import { readTextFileToArray } from "utils/readText";

function ResverseCid() {
  const navigate = useNavigate();
  const location = useLocation();
  const props = location.state;

  const inputFileRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [fileContent, setFileContent] = useState("");
  const [dataList, setDataList] = useState([]);
  const [updGridFailded, setUpdGridFailed] = useState([]);
  const [updRpmethFailded, setUpdRpmethFailed] = useState([]);

  useEffect(() => {
    if (props === null) {
      navigate("/ndrs-gsb-register/sign-in");
    }
  }, [updGridFailded, updRpmethFailded]);
  const handleImportData = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    console.log("START REVERSE CID.");

    var updGridFaildedTxt = "";
    var updRpmethFaildedTxt = "";

    if (dataList.length === 0) {
      setIsLoading(false);
      setIsAlert(true);
      setAlertType("error");
      setAlertMsg("กรุณาเลือกไฟล์ข้อมูลก่อนนำเข้า");
      return;
    } else {
      var cidList = [];
      for (let i = 0; i < dataList.length; i++) {
        console.log("CID : " + dataList[i].CID);
        let rsBody = {
          cid: dataList[i].CID,
        };
        cidList.push(rsBody);
      }
      let payload = {
        cidList: cidList,
      };
      console.log(payload);
      const res = await exportCidToReverseDebtTracking(payload);
      if (res.status_flag) {
        setIsLoading(false);
        console.log("successRowUpdGrid => ", res.rsBody.successRowUpdGrid);
        console.log("successRowUpdRpmeth => ", res.rsBody.successRowUpdRpmeth);
        setIsAlert(true);
        setAlertMsg("ส่งเปลี่ยนลำดับการตัดบัญชีกลับสำเร็จ");
        setAlertType("success");
        if (res.rsBody.failRowUpdGrid.length > 0) {
          for (let i = 0; i < res.rsBody.failRowUpdGrid.length; i++) {
            updGridFaildedTxt += res.rsBody.failRowUpdGrid[i].concat(" \n");
          }
          setUpdGridFailed(updGridFaildedTxt);
        }

        if (res.rsBody.failRowUpdRpmeth.length > 0) {
          for (let i = 0; i < res.rsBody.failRowUpdRpmeth.length; i++) {
            updRpmethFaildedTxt += res.rsBody.failRowUpdRpmeth[i].concat(" \n");
          }
          setUpdRpmethFailed(updRpmethFaildedTxt);
        }
      } else {
        setIsLoading(false);
        setIsAlert(true);
        setAlertMsg("ไม่สามารถส่งเปลี่ยนลำดับการตัดบัญชีกลับได้");
        setAlertType("error");
        console.error(res.status_message);
      }
    }

    setDataList([]);
    if (inputFileRef.current) {
      inputFileRef.current.value = "";
    }
    console.log("END REVERSE CID.");
  };
  const handleFileChange = (event) => {
    console.log(event);
    const file = event.target.files[0];
    if (file) {
      // เรียกใช้ฟังก์ชันสำหรับอ่านไฟล์
      readFile(file);
    }
  };

  const readFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      const array = readTextFileToArray(content);
      if (array.length <= 3000) {
        setFileContent(content);
        setDataList(array);
      } else {
        setIsLoading(false);
        setIsAlert(true);
        setAlertMsg("กรุณา upload ครั้งละไม่เกิน 3,000 บัญชี");
        setAlertType("error");
      }
    };
    reader.readAsText(file); // อ่านไฟล์เป็น text
  };

  const handleClearData = (e) => {
    e.preventDefault();
    setIsLoading(false);
    setIsAlert(false);
    setAlertMsg("");
    setAlertType("");
    setFileContent("");
    setDataList([]);
    setUpdGridFailed([]);
    setUpdRpmethFailed([]);
    if (inputFileRef.current) {
      inputFileRef.current.value = "";
    }
  };
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "https://ln15.gsb.or.th/ndrs",
          label: "GSB NDRS Website",
          color: "default",
        }}
        transparent
        light
      />
      <MKBox
        minHeight="45vh"
        width="100%"
        bgColor="#1e88e5"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h2"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              การลงทะเบียนเข้าร่วมมาตรการผ่อนปรนเงื่อนไขการชำระหนี้
            </MKTypography>
            <MKTypography variant="h5" color="white" opacity={1} mt={1} mb={3}>
              มาตรการให้ความช่วยเหลือลูกหนี้ที่มีสถานะเป็นหนี้เสียที่มีภาระหนี้เงินต้นและดอกเบี้ยไม่เกิน
              1 แสนบาท
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={{ xs: 6, sm: 12 }}>
          <Container>
            {isAlert ? (
              <>
                <MKAlert color={alertType} autoHideDuration={15000} dismissible>
                  {alertMsg}
                </MKAlert>
                <br />
              </>
            ) : null}
            <Grid container item xs={12} spacing={5} justifyContent="center" mx="auto">
              <MKTypography
                variant="h5"
                fontWeight="medium"
                color="primary"
                justifyContent="center"
              >
                Import Reverse
              </MKTypography>
            </Grid>
            <Grid container item xs={12} justifyContent="center" py={4}>
              <Grid container justifyContent="center" spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <MKTypography variant="body2" fontWeight="medium" color="dark">
                    เลือกไฟล์ Text สำหรับนำเข้าข้อมูล (.txt)
                  </MKTypography>
                  <MKInput
                    type="file"
                    color="primary"
                    onChange={handleFileChange}
                    inputProps={{
                      accept: ".txt",
                    }}
                    inputRef={inputFileRef}
                    fullWidth
                  />
                  <br />
                  <br />
                  <MKTypography variant="body2" fontWeight="medium" color="dark">
                    ข้อมูลที่เตรียมนำเข้า
                  </MKTypography>
                  {fileContent ? (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      {fileContent}
                    </pre>
                  ) : (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      -
                    </pre>
                  )}
                </Grid>
              </Grid>
              <Grid container justifyContent="center" py={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <MKTypography variant="body2" fontWeight="medium" color="error">
                    เลขบัญชี Primary ที่เปลี่ยนลำดับการตัดกลับไม่สำเร็จ
                  </MKTypography>
                  {updGridFailded.length > 0 ? (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      {updGridFailded}
                    </pre>
                  ) : (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      -
                    </pre>
                  )}
                </Grid>
              </Grid>
              <Grid container justifyContent="center" py={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <MKTypography variant="body2" fontWeight="medium" color="error">
                    เลขบัญชี Sub ที่เปลี่ยนลำดับการตัดกลับไม่สำเร็จ
                  </MKTypography>
                  {updRpmethFailded.length > 0 ? (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      {updRpmethFailded}
                    </pre>
                  ) : (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      -
                    </pre>
                  )}
                </Grid>
              </Grid>
              <Grid container justifyContent="center" py={2}>
                <MKButton variant="contained" color="success" onClick={handleImportData}>
                  นำเข้าข้อมูล
                </MKButton>
                &nbsp;
                <MKButton variant="contained" color="secondary" onClick={handleClearData}>
                  ล้างข้อมูล
                </MKButton>
                &nbsp;
                <MKButton
                  variant="contained"
                  color="dark"
                  onClick={() => navigate("/ndrs-gsb-register/sign-in")}
                >
                  Logout
                </MKButton>
              </Grid>
              {isLoading ? (
                <Grid container justifyContent="center">
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Stack sx={{ width: "50%" }}>
                      <LinearProgress color="primary" />
                    </Stack>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </Container>
        </MKBox>
      </Card>
    </>
  );
}

ResverseCid.defaultProps = {
  user: {},
};

ResverseCid.propTypes = {
  user: PropTypes.shape({
    title: PropTypes.string,
    postalCode: PropTypes.string,
    displayName: PropTypes.string,
    otherPager: PropTypes.string,
    department: PropTypes.string,
    streetAddress: PropTypes.string,
    employeeType: PropTypes.string,
    employeeID: PropTypes.string,
    division: PropTypes.string,
    token: PropTypes.string,
    accessToken: PropTypes.string,
    isLogin: PropTypes.bool,
    isAdmin: PropTypes.bool,
    isCallCenter: PropTypes.bool,
    isIt: PropTypes.bool,
  }),
};

export default ResverseCid;
